import { TrainingEvent } from '../../models/training/training-event.model';

export enum ActionTypes {
  RememberTrainingEvents = '[RememberTrainingEvents] action',
  ResetTrainingEvents = '[ResetTrainingEvents] action',
  RememberTrainingEvent = '[RememberTrainingEvent] action',
  UpdatePinnedEvents = '[UpdatePinnedEvents] action'
}

export class RememberTrainingEvents {
  public static readonly type = ActionTypes.RememberTrainingEvents;
  constructor(
    public payload: TrainingEvent[],
    public isLoadedSuccessfully: boolean,
    public isSMSNotificationSettingEnabled?: boolean,
    public isProfileSettingEnabled?: boolean
  ) {}
}

export class ResetTrainingEvents {
  public static readonly type = ActionTypes.ResetTrainingEvents;
  constructor() {}
}

export class RememberTrainingEvent {
  public static readonly type = ActionTypes.RememberTrainingEvent;
  constructor(
    public payload: TrainingEvent,
    public isLoadedSuccessfully: boolean,
    public isSMSNotificationSettingEnabled?: boolean,
    public isProfileSettingEnabled?: boolean
  ) {}
}

export class UpdatePinnedEvents {
  public static readonly type = ActionTypes.UpdatePinnedEvents;
  constructor(public payload: TrainingEvent[]) {}
}
